var map = {
	"./bg/CL012-001.jpg": 95,
	"./bg/CL032-001.jpg": 96,
	"./bg/CL054-001.jpg": 97,
	"./bg/CL194-001.jpg": 98,
	"./bg/CL201-001.jpg": 99,
	"./bg/CLO18-001.jpg": 100,
	"./stamps/01_CL_04.png": 101,
	"./stamps/02_CH_PRI_03.png": 102,
	"./stamps/03_TARA_01.png": 103,
	"./stamps/04_TARA_PRI_02.png": 104,
	"./stamps/05_JET_03.png": 105,
	"./stamps/06_JET_PRI_02.png": 106,
	"./stamps/07_LC_04.png": 107,
	"./stamps/08_LC_05.png": 108,
	"./stamps/09_PROP_VET_11-2.png": 109,
	"./stamps/10_PROP_VET_11-3.png": 110,
	"./stamps/11_PROP_VET_11-1.png": 111,
	"./stamps/12_PROP_VET_12.png": 112,
	"./stamps/13_PROP_08.png": 113,
	"./stamps/13_PROP_VET_08.png": 114,
	"./stamps/14_prop_16.png": 115,
	"./stamps/15_CC_V_Balloon.png": 116,
	"./stamps/16_CC_V_Helicopter.png": 117,
	"./stamps/17_CC_V_Sleigh.png": 118,
	"./stamps/18_CC_V_TrainEngine.png": 119,
	"./stamps/19_CP637-001-PLANE-3.png": 120,
	"./stamps/20_PROP_PRI_02.png": 121,
	"./stamps/21_PROP_VET_01.png": 122,
	"./stamps/22_CC_V_BoulderCar.png": 123,
	"./stamps/23_PROP_01.png": 124,
	"./stamps/24_prop_19.png": 125,
	"./stamps/25_PROP_05.png": 126,
	"./stamps/26_PROP_BAL_04.png": 127,
	"./stamps/28_PROP_BAK_06.png": 128,
	"./stamps/29_PROP_09.png": 129,
	"./stamps/30_ICON_10_A.png": 130,
	"./stamps/31_ICON_10_B.png": 131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 143;


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe ^\.\/.*$
// module id = 143
// module chunks = 0